import React from 'react';

// Shared shimmer block — every page skeleton paints its layout out of these.
export const Bar = ({ className }) => (
  <span className={`relative block overflow-hidden rounded bg-black/[0.05] ${className}`}>
    <span className="animate-shimmer absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent" />
  </span>
);

export default Bar;
